import queryString from 'query-string';
import type { Location } from 'history';
import type { Store } from 'redux';

export function extractEmailAuthToken(router: { location?: Location }) {
  const { search = '' } = (router && router.location) || {};
  const { auth_token: emailAuthToken } = queryString.parse(search) || {};
  return emailAuthToken;
}

/**
 * Returns whether there is an email auth token present.
 *
 * @param {*} param0
 */
export function isEmailAuthTokenPresent({ getState }: Store): boolean {
  const { router } = getState();
  return !!extractEmailAuthToken(router);
}
